var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidsbig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.34pt",
    height: "20.34pt",
    viewBox: "0 0 20.34 20.34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.0003,-0.0001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.383 5.2071 C 15.383 2.3321 13.051 0 10.1721 0 C 7.2932 0 4.9612 2.332 4.9612 5.207 H 5.2112 V 4.957 C 2.3362 4.957 0.0042 7.289 0.0042 10.168 C 0.0042 13.047 2.3362 15.379 5.2112 15.379 V 15.129 H 4.9612 C 4.9612 18.008 7.2932 20.34 10.1721 20.34 C 13.051 20.34 15.383 18.008 15.383 15.129 H 15.133 V 15.379 C 18.008 15.379 20.34 13.047 20.34 10.168 C 20.34 7.289 18.008 4.957 15.133 4.957 V 5.457 C 16.4338 5.457 17.6096 5.9843 18.4611 6.8358 C 19.3126 7.6873 19.84 8.8631 19.84 10.1639 C 19.84 11.4647 19.3126 12.6405 18.4611 13.492 C 17.6096 14.3435 16.4338 14.8709 15.133 14.8709 H 14.883 V 15.1209 C 14.883 16.4246 14.3556 17.5965 13.5041 18.452 C 12.6526 19.3036 11.4768 19.8309 10.176 19.8309 C 8.8752 19.8309 7.6954 19.3036 6.8439 18.452 C 5.9884 17.5965 5.461 16.4246 5.461 15.1209 V 14.8709 H 5.211 C 3.9102 14.8709 2.7344 14.3435 1.8829 13.492 C 1.0274 12.6365 0.5 11.4607 0.5 10.1599 C 0.5 8.8591 1.0274 7.6833 1.8829 6.8318 C 2.7344 5.9763 3.9102 5.4489 5.211 5.4489 H 5.461 V 5.1989 C 5.461 3.8981 5.9884 2.7223 6.8439 1.8708 C 7.6954 1.0153 8.8752 0.4879 10.176 0.4879 C 11.4768 0.4879 12.6526 1.0153 13.5041 1.8708 C 14.3596 2.7223 14.887 3.8981 14.887 5.1989 Z",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsbig);
export default __webpack_public_path__ + "static/media/kidsbig.441a40c23dd238f3affb85732ab2e22a.svg";
export { ForwardRef as ReactComponent };